/* ══════════════════════════════════════════════════════
   PROFESSION MAP — Customizes experience per profession type
   Selected during onboarding, changeable from Settings.
   Affects: expense categories, voice keywords, pricing examples,
   community channel recommendations.
   ══════════════════════════════════════════════════════ */

export const PROFESSION_MAP = {
  beauty: {
    label: 'Beauty & Nails',
    icon: '💅',
    subtitle: 'Nail tech, lash artist, esthetician',
    expenseCategories: [
      { id: 'supplies', label: 'Products & Supplies', icon: '🧴' },
      { id: 'rent', label: 'Booth / Studio Rent', icon: '🏢' },
      { id: 'equipment', label: 'Tools & Equipment', icon: '🔧' },
      { id: 'education', label: 'Training & Certs', icon: '📚' },
      { id: 'marketing', label: 'Marketing', icon: '📣' },
      { id: 'software', label: 'Booking Software', icon: '💻' },
      { id: 'insurance', label: 'Insurance', icon: '🛡️' },
      { id: 'biz_other', label: 'Other', icon: '📦' },
    ],
    voiceKeywords: ['full set', 'fill', 'gel', 'acrylic', 'pedicure', 'manicure', 'lash', 'brow', 'wax', 'facial', 'extensions', 'tips', 'soak off', 'nail art', 'dip powder'],
    pricingExamples: [
      { name: 'Full Set', productCost: '15', duration: '90', overheadPerHour: '12' },
      { name: 'Fill', productCost: '8', duration: '60', overheadPerHour: '12' },
      { name: 'Gel Manicure', productCost: '6', duration: '45', overheadPerHour: '12' },
    ],
    commonMerchants: [
      { name: 'Sally Beauty',  aliases: ['sally beauty', 'sallys', 'sally'],          category: 'supplies',  deductible: true,  seedConfidence: 'high'   },
      { name: 'CosmoProf',     aliases: ['cosmoprof', 'cosmo prof'],                  category: 'supplies',  deductible: true,  seedConfidence: 'high'   },
      { name: 'Vagaro',        aliases: ['vagaro'],                                   category: 'software',  deductible: true,  seedConfidence: 'high'   },
      { name: 'GlossGenius',   aliases: ['glossgenius', 'gloss genius'],              category: 'software',  deductible: true,  seedConfidence: 'high'   },
      { name: 'StyleSeat',     aliases: ['styleseat', 'style seat'],                  category: 'software',  deductible: true,  seedConfidence: 'high'   },
      { name: 'Square',        aliases: ['square inc', 'square', 'sq'],           category: 'software',  deductible: true,  seedConfidence: 'high'   },
      { name: 'Amazon',        aliases: ['amazon', 'amzn'],             category: 'supplies',  deductible: true,  seedConfidence: 'medium' },
      { name: 'Costco',        aliases: ['costco'],                                   category: 'supplies',  deductible: true,  seedConfidence: 'medium' },
      { name: 'Target',        aliases: ['target'],                                   category: 'supplies',  deductible: true,  seedConfidence: 'medium' },
      { name: 'Walmart',       aliases: ['walmart', 'wal mart'],                      category: 'supplies',  deductible: true,  seedConfidence: 'medium' },
    ],
    communityChannels: ['general', 'tips', 'wins'],
  },
  hair: {
    label: 'Hair Styling',
    icon: '💇',
    subtitle: 'Stylist, barber, colorist',
    expenseCategories: [
      { id: 'supplies', label: 'Color & Products', icon: '🧴' },
      { id: 'rent', label: 'Chair / Booth Rent', icon: '🏢' },
      { id: 'equipment', label: 'Tools & Dryers', icon: '🔧' },
      { id: 'education', label: 'Training & Shows', icon: '📚' },
      { id: 'marketing', label: 'Marketing', icon: '📣' },
      { id: 'software', label: 'Booking Software', icon: '💻' },
      { id: 'insurance', label: 'Insurance', icon: '🛡️' },
      { id: 'biz_other', label: 'Other', icon: '📦' },
    ],
    voiceKeywords: ['cut', 'color', 'highlights', 'balayage', 'blowout', 'trim', 'style', 'keratin', 'perm', 'braids', 'weave', 'extensions', 'shave', 'beard'],
    pricingExamples: [
      { name: 'Haircut', productCost: '3', duration: '45', overheadPerHour: '15' },
      { name: 'Color & Cut', productCost: '25', duration: '120', overheadPerHour: '15' },
    ],
    commonMerchants: [
      { name: 'Sally Beauty',  aliases: ['sally beauty', 'sallys', 'sally'],          category: 'supplies',  deductible: true,  seedConfidence: 'high'   },
      { name: 'CosmoProf',     aliases: ['cosmoprof', 'cosmo prof'],                  category: 'supplies',  deductible: true,  seedConfidence: 'high'   },
      { name: 'Sam Villa',     aliases: ['sam villa', 'samvilla'],                    category: 'equipment', deductible: true,  seedConfidence: 'high'   },
      { name: 'Wella',         aliases: ['wella'],                                    category: 'supplies',  deductible: true,  seedConfidence: 'high'   },
      { name: 'Redken',        aliases: ['redken'],                                   category: 'supplies',  deductible: true,  seedConfidence: 'high'   },
      { name: "L'Oreal Pro",   aliases: ['loreal professional', 'loreal pro'],        category: 'supplies',  deductible: true,  seedConfidence: 'high'   },
      { name: 'Vagaro',        aliases: ['vagaro'],                                   category: 'software',  deductible: true,  seedConfidence: 'high'   },
      { name: 'GlossGenius',   aliases: ['glossgenius', 'gloss genius'],              category: 'software',  deductible: true,  seedConfidence: 'high'   },
      { name: 'StyleSeat',     aliases: ['styleseat', 'style seat'],                  category: 'software',  deductible: true,  seedConfidence: 'high'   },
      { name: 'Square',        aliases: ['square inc', 'square', 'sq'],           category: 'software',  deductible: true,  seedConfidence: 'high'   },
      { name: 'Amazon',        aliases: ['amazon', 'amzn'],             category: 'supplies',  deductible: true,  seedConfidence: 'medium' },
      { name: 'Costco',        aliases: ['costco'],                                   category: 'supplies',  deductible: true,  seedConfidence: 'medium' },
    ],
    communityChannels: ['general', 'tips', 'wins'],
  },
  tattoo: {
    label: 'Tattoo & Piercing',
    icon: '🎨',
    subtitle: 'Tattoo artist, piercer, body art',
    expenseCategories: [
      { id: 'supplies', label: 'Ink & Needles', icon: '🧴' },
      { id: 'rent', label: 'Studio Rent', icon: '🏢' },
      { id: 'equipment', label: 'Machines & Equipment', icon: '🔧' },
      { id: 'education', label: 'Conventions & Training', icon: '📚' },
      { id: 'marketing', label: 'Portfolio & Marketing', icon: '📣' },
      { id: 'software', label: 'Software', icon: '💻' },
      { id: 'insurance', label: 'Insurance & Licensing', icon: '🛡️' },
      { id: 'biz_other', label: 'Other', icon: '📦' },
    ],
    voiceKeywords: ['flash', 'custom', 'portrait', 'sleeve', 'cover up', 'touch up', 'lettering', 'piercing', 'consultation', 'deposit', 'hourly'],
    pricingExamples: [
      { name: 'Flash Piece', productCost: '8', duration: '60', overheadPerHour: '20' },
      { name: 'Custom (hourly)', productCost: '12', duration: '60', overheadPerHour: '20' },
    ],
    commonMerchants: [
      { name: 'Eternal Ink',         aliases: ['eternal ink', 'eternal'],             category: 'supplies',  deductible: true,  seedConfidence: 'high'   },
      { name: 'Intenze',             aliases: ['intenze'],                            category: 'supplies',  deductible: true,  seedConfidence: 'high'   },
      { name: 'Kingpin Tattoo',      aliases: ['kingpin tattoo', 'kingpin'],          category: 'supplies',  deductible: true,  seedConfidence: 'high'   },
      { name: 'FK Irons',            aliases: ['fk irons', 'fkirons'],                category: 'equipment', deductible: true,  seedConfidence: 'high'   },
      { name: 'Cheyenne',            aliases: ['cheyenne tattoo', 'cheyenne'],        category: 'equipment', deductible: true,  seedConfidence: 'high'   },
      { name: 'Sorry Mom',           aliases: ['sorry mom'],                          category: 'supplies',  deductible: true,  seedConfidence: 'high'   },
      { name: 'Booksy',              aliases: ['booksy'],                             category: 'software',  deductible: true,  seedConfidence: 'high'   },
      { name: 'Square',              aliases: ['square inc', 'square', 'sq'],    category: 'software',  deductible: true,  seedConfidence: 'high'   },
      { name: 'Amazon',              aliases: ['amazon', 'amzn'],       category: 'supplies',  deductible: true,  seedConfidence: 'medium' },
    ],
    communityChannels: ['general', 'tips', 'wins', 'business'],
  },
  photography: {
    label: 'Photography & Video',
    icon: '📸',
    subtitle: 'Photographer, videographer, editor',
    expenseCategories: [
      { id: 'equipment', label: 'Camera & Gear', icon: '📷' },
      { id: 'software', label: 'Editing Software', icon: '💻' },
      { id: 'rent', label: 'Studio Rental', icon: '🏢' },
      { id: 'supplies', label: 'Props & Prints', icon: '🧴' },
      { id: 'marketing', label: 'Website & Marketing', icon: '📣' },
      { id: 'education', label: 'Workshops', icon: '📚' },
      { id: 'insurance', label: 'Equipment Insurance', icon: '🛡️' },
      { id: 'biz_other', label: 'Other', icon: '📦' },
    ],
    voiceKeywords: ['session', 'shoot', 'wedding', 'portrait', 'headshot', 'event', 'editing', 'prints', 'album', 'package', 'retainer', 'deposit'],
    pricingExamples: [
      { name: 'Portrait Session', productCost: '5', duration: '120', overheadPerHour: '25' },
      { name: 'Wedding Package', productCost: '50', duration: '480', overheadPerHour: '25' },
    ],
    commonMerchants: [
      { name: 'B&H Photo',     aliases: ['b h photo', 'bhphoto', 'b and h'],          category: 'equipment', deductible: true,  seedConfidence: 'high'   },
      { name: 'Adorama',       aliases: ['adorama'],                                  category: 'equipment', deductible: true,  seedConfidence: 'high'   },
      { name: 'Lensrentals',   aliases: ['lensrentals', 'lens rentals'],              category: 'equipment', deductible: true,  seedConfidence: 'high'   },
      { name: 'Adobe',         aliases: ['adobe'],                                    category: 'software',  deductible: true,  seedConfidence: 'high'   },
      { name: 'Lightroom',     aliases: ['lightroom'],                                category: 'software',  deductible: true,  seedConfidence: 'high'   },
      { name: 'Pixieset',      aliases: ['pixieset'],                                 category: 'software',  deductible: true,  seedConfidence: 'high'   },
      { name: 'ShootProof',    aliases: ['shootproof', 'shoot proof'],                category: 'software',  deductible: true,  seedConfidence: 'high'   },
      { name: 'SmugMug',       aliases: ['smugmug'],                                  category: 'software',  deductible: true,  seedConfidence: 'high'   },
      { name: 'Square',        aliases: ['square inc', 'square', 'sq'],           category: 'software',  deductible: true,  seedConfidence: 'high'   },
      { name: 'Best Buy',      aliases: ['best buy', 'bestbuy'],                      category: 'equipment', deductible: true,  seedConfidence: 'medium' },
      { name: 'Amazon',        aliases: ['amazon', 'amzn'],             category: 'equipment', deductible: true,  seedConfidence: 'medium' },
    ],
    communityChannels: ['general', 'tips', 'business'],
  },
  fitness: {
    label: 'Fitness & Wellness',
    icon: '💪',
    subtitle: 'Personal trainer, yoga instructor, coach',
    expenseCategories: [
      { id: 'rent', label: 'Gym / Studio Space', icon: '🏢' },
      { id: 'equipment', label: 'Equipment', icon: '🔧' },
      { id: 'education', label: 'Certifications', icon: '📚' },
      { id: 'marketing', label: 'Marketing', icon: '📣' },
      { id: 'software', label: 'Booking & Apps', icon: '💻' },
      { id: 'insurance', label: 'Liability Insurance', icon: '🛡️' },
      { id: 'supplies', label: 'Supplements & Supplies', icon: '🧴' },
      { id: 'biz_other', label: 'Other', icon: '📦' },
    ],
    voiceKeywords: ['session', 'training', 'class', 'package', 'monthly', 'bootcamp', 'private', 'group', 'consultation', 'assessment', 'plan'],
    pricingExamples: [
      { name: 'Private Session', productCost: '0', duration: '60', overheadPerHour: '15' },
      { name: 'Group Class', productCost: '0', duration: '60', overheadPerHour: '30' },
    ],
    commonMerchants: [
      { name: 'NASM',          aliases: ['nasm'],                                     category: 'education', deductible: true,  seedConfidence: 'high'   },
      { name: 'ACE Fitness',   aliases: ['ace fitness', 'acefitness'],                category: 'education', deductible: true,  seedConfidence: 'high'   },
      { name: 'Trainerize',    aliases: ['trainerize'],                               category: 'software',  deductible: true,  seedConfidence: 'high'   },
      { name: 'MyFitnessPal',  aliases: ['myfitnesspal', 'my fitness pal'],           category: 'software',  deductible: true,  seedConfidence: 'high'   },
      { name: 'Square',        aliases: ['square inc', 'square', 'sq'],           category: 'software',  deductible: true,  seedConfidence: 'high'   },
      { name: 'Mindbody',      aliases: ['mindbody'],                                 category: 'software',  deductible: true,  seedConfidence: 'high'   },
      { name: 'Beachbody',     aliases: ['beachbody'],                                category: 'education', deductible: true,  seedConfidence: 'high'   },
      { name: 'Amazon',        aliases: ['amazon', 'amzn'],             category: 'equipment', deductible: true,  seedConfidence: 'medium' },
      { name: 'Costco',        aliases: ['costco'],                                   category: 'equipment', deductible: true,  seedConfidence: 'medium' },
    ],
    communityChannels: ['general', 'tips', 'wins'],
  },
  pet: {
    label: 'Pet Services',
    icon: '🐾',
    subtitle: 'Dog groomer, pet sitter, walker',
    expenseCategories: [
      { id: 'supplies', label: 'Grooming Supplies', icon: '🧴' },
      { id: 'equipment', label: 'Equipment', icon: '🔧' },
      { id: 'rent', label: 'Shop / Van', icon: '🏢' },
      { id: 'marketing', label: 'Marketing', icon: '📣' },
      { id: 'insurance', label: 'Insurance & Bonding', icon: '🛡️' },
      { id: 'software', label: 'Scheduling Software', icon: '💻' },
      { id: 'education', label: 'Training', icon: '📚' },
      { id: 'biz_other', label: 'Other', icon: '📦' },
    ],
    voiceKeywords: ['groom', 'bath', 'walk', 'sitting', 'boarding', 'daycare', 'nail trim', 'deshed', 'puppy', 'drop-in'],
    pricingExamples: [
      { name: 'Full Groom', productCost: '8', duration: '90', overheadPerHour: '10' },
      { name: 'Bath & Brush', productCost: '5', duration: '45', overheadPerHour: '10' },
    ],
    commonMerchants: [
      { name: 'Chewy',         aliases: ['chewy'],                                    category: 'supplies',  deductible: true,  seedConfidence: 'high'   },
      { name: 'PetSmart',      aliases: ['petsmart', 'pet smart'],                    category: 'supplies',  deductible: true,  seedConfidence: 'high'   },
      { name: 'Petco',         aliases: ['petco'],                                    category: 'supplies',  deductible: true,  seedConfidence: 'high'   },
      { name: 'Trupanion',     aliases: ['trupanion'],                                category: 'insurance', deductible: true,  seedConfidence: 'high'   },
      { name: 'Booksy',        aliases: ['booksy'],                                   category: 'software',  deductible: true,  seedConfidence: 'high'   },
      { name: 'Square',        aliases: ['square inc', 'square', 'sq'],           category: 'software',  deductible: true,  seedConfidence: 'high'   },
      { name: 'Amazon',        aliases: ['amazon', 'amzn'],             category: 'supplies',  deductible: true,  seedConfidence: 'medium' },
      { name: 'Costco',        aliases: ['costco'],                                   category: 'supplies',  deductible: true,  seedConfidence: 'medium' },
    ],
    communityChannels: ['general', 'tips', 'wins'],
  },
  creative: {
    label: 'Creative & Design',
    icon: '🎨',
    subtitle: 'Graphic designer, artist, DJ, florist',
    expenseCategories: [
      { id: 'software', label: 'Software & Licenses', icon: '💻' },
      { id: 'supplies', label: 'Materials & Supplies', icon: '🧴' },
      { id: 'equipment', label: 'Equipment', icon: '🔧' },
      { id: 'rent', label: 'Studio / Workspace', icon: '🏢' },
      { id: 'marketing', label: 'Portfolio & Marketing', icon: '📣' },
      { id: 'education', label: 'Courses & Workshops', icon: '📚' },
      { id: 'insurance', label: 'Insurance', icon: '🛡️' },
      { id: 'biz_other', label: 'Other', icon: '📦' },
    ],
    voiceKeywords: ['project', 'logo', 'design', 'commission', 'gig', 'event', 'booking', 'package', 'hourly', 'retainer', 'wedding', 'arrangement'],
    pricingExamples: [
      { name: 'Logo Design', productCost: '0', duration: '300', overheadPerHour: '10' },
      { name: 'DJ Set (4hr)', productCost: '0', duration: '240', overheadPerHour: '15' },
    ],
    commonMerchants: [
      { name: 'Adobe',         aliases: ['adobe'],                                    category: 'software',  deductible: true,  seedConfidence: 'high'   },
      { name: 'Domestika',     aliases: ['domestika'],                                category: 'education', deductible: true,  seedConfidence: 'high'   },
      { name: 'B&H Photo',     aliases: ['b h photo', 'bhphoto', 'b and h'],          category: 'equipment', deductible: true,  seedConfidence: 'high'   },
      { name: 'Wacom',         aliases: ['wacom'],                                    category: 'equipment', deductible: true,  seedConfidence: 'high'   },
      { name: 'Patreon',       aliases: ['patreon'],                                  category: 'software',  deductible: true,  seedConfidence: 'high'   },
      { name: 'Etsy',          aliases: ['etsy'],                                     category: 'marketing', deductible: true,  seedConfidence: 'high'   },
      { name: 'Squarespace',   aliases: ['squarespace'],                              category: 'software',  deductible: true,  seedConfidence: 'high'   },
      { name: 'Apple',         aliases: ['apple', 'apple inc'],                   category: 'equipment', deductible: true,  seedConfidence: 'medium' },
      { name: 'Amazon',        aliases: ['amazon', 'amzn'],             category: 'supplies',  deductible: true,  seedConfidence: 'medium' },
    ],
    communityChannels: ['general', 'tips', 'business'],
  },
  trades: {
    label: 'Trades & Home Services',
    icon: '🔨',
    subtitle: 'Handyman, plumber, electrician, cleaner',
    expenseCategories: [
      { id: 'supplies', label: 'Materials & Parts', icon: '🧴' },
      { id: 'equipment', label: 'Tools & Equipment', icon: '🔧' },
      { id: 'rent', label: 'Vehicle / Shop', icon: '🚗' },
      { id: 'insurance', label: 'Insurance & Bonding', icon: '🛡️' },
      { id: 'marketing', label: 'Advertising', icon: '📣' },
      { id: 'education', label: 'Licensing & Training', icon: '📚' },
      { id: 'software', label: 'Software', icon: '💻' },
      { id: 'biz_other', label: 'Other', icon: '📦' },
    ],
    voiceKeywords: ['job', 'service call', 'repair', 'install', 'estimate', 'quote', 'hourly', 'project', 'cleaning', 'maintenance'],
    pricingExamples: [
      { name: 'Service Call', productCost: '20', duration: '60', overheadPerHour: '15' },
      { name: 'Deep Clean', productCost: '15', duration: '180', overheadPerHour: '8' },
    ],
    commonMerchants: [
      { name: 'Home Depot',    aliases: ['home depot', 'homedepot', 'thd'],           category: 'supplies',  deductible: true,  seedConfidence: 'high'   },
      { name: 'Lowes',         aliases: ['lowes', 'lowe s'],                          category: 'supplies',  deductible: true,  seedConfidence: 'high'   },
      { name: 'Harbor Freight',aliases: ['harbor freight', 'harborfreight'],          category: 'equipment', deductible: true,  seedConfidence: 'high'   },
      { name: 'Northern Tool', aliases: ['northern tool'],                            category: 'equipment', deductible: true,  seedConfidence: 'high'   },
      { name: 'Grainger',      aliases: ['grainger'],                                 category: 'supplies',  deductible: true,  seedConfidence: 'high'   },
      { name: 'Ace Hardware',  aliases: ['ace hardware', 'acehardware'],              category: 'supplies',  deductible: true,  seedConfidence: 'high'   },
      { name: 'Jobber',        aliases: ['jobber'],                                   category: 'software',  deductible: true,  seedConfidence: 'high'   },
      { name: 'Housecall Pro', aliases: ['housecall pro', 'housecallpro'],            category: 'software',  deductible: true,  seedConfidence: 'high'   },
      { name: 'Amazon',        aliases: ['amazon', 'amzn'],             category: 'supplies',  deductible: true,  seedConfidence: 'medium' },
    ],
    communityChannels: ['general', 'business'],
  },
  coaching: {
    label: 'Coaching & Consulting',
    icon: '🎯',
    subtitle: 'Life coach, tutor, consultant',
    expenseCategories: [
      { id: 'software', label: 'Software & Tools', icon: '💻' },
      { id: 'marketing', label: 'Marketing & Ads', icon: '📣' },
      { id: 'education', label: 'Certifications', icon: '📚' },
      { id: 'rent', label: 'Office / Coworking', icon: '🏢' },
      { id: 'insurance', label: 'Professional Insurance', icon: '🛡️' },
      { id: 'supplies', label: 'Materials', icon: '🧴' },
      { id: 'equipment', label: 'Equipment', icon: '🔧' },
      { id: 'biz_other', label: 'Other', icon: '📦' },
    ],
    voiceKeywords: ['session', 'coaching', 'consulting', 'call', 'package', 'retainer', 'monthly', 'workshop', 'tutoring', 'lesson', 'class'],
    pricingExamples: [
      { name: '1-on-1 Session', productCost: '0', duration: '60', overheadPerHour: '5' },
      { name: 'Group Workshop', productCost: '10', duration: '120', overheadPerHour: '20' },
    ],
    commonMerchants: [
      { name: 'Calendly',         aliases: ['calendly'],                              category: 'software',  deductible: true,  seedConfidence: 'high'   },
      { name: 'Acuity',           aliases: ['acuity scheduling', 'acuity'],           category: 'software',  deductible: true,  seedConfidence: 'high'   },
      { name: 'Zoom',             aliases: ['zoom', 'zoom video'],                 category: 'software',  deductible: true,  seedConfidence: 'high'   },
      { name: 'Notion',           aliases: ['notion'],                                category: 'software',  deductible: true,  seedConfidence: 'high'   },
      { name: 'ConvertKit',       aliases: ['convertkit', 'convert kit'],             category: 'marketing', deductible: true,  seedConfidence: 'high'   },
      { name: 'Mailchimp',        aliases: ['mailchimp', 'mail chimp'],               category: 'marketing', deductible: true,  seedConfidence: 'high'   },
      { name: 'Squarespace',      aliases: ['squarespace'],                           category: 'software',  deductible: true,  seedConfidence: 'high'   },
      { name: 'Stripe',           aliases: ['stripe'],                                category: 'software',  deductible: true,  seedConfidence: 'high'   },
      { name: 'Amazon',           aliases: ['amazon', 'amzn'],          category: 'supplies',  deductible: true,  seedConfidence: 'medium' },
    ],
    communityChannels: ['general', 'tips', 'business'],
  },
  other: {
    label: 'Other / General',
    icon: '⚡',
    subtitle: 'Any independent service work',
    expenseCategories: [
      { id: 'supplies', label: 'Supplies', icon: '🧴' },
      { id: 'rent', label: 'Rent / Space', icon: '🏢' },
      { id: 'equipment', label: 'Equipment', icon: '🔧' },
      { id: 'software', label: 'Software', icon: '💻' },
      { id: 'marketing', label: 'Marketing', icon: '📣' },
      { id: 'insurance', label: 'Insurance', icon: '🛡️' },
      { id: 'education', label: 'Education', icon: '📚' },
      { id: 'biz_other', label: 'Other', icon: '📦' },
    ],
    voiceKeywords: ['service', 'session', 'project', 'job', 'gig', 'client', 'payment', 'invoice', 'hourly', 'package'],
    pricingExamples: [
      { name: 'Service', productCost: '10', duration: '60', overheadPerHour: '10' },
    ],
    commonMerchants: [
      { name: 'Square',           aliases: ['square inc', 'square', 'sq'],        category: 'software',  deductible: true,  seedConfidence: 'high'   },
      { name: 'Stripe',           aliases: ['stripe'],                                category: 'software',  deductible: true,  seedConfidence: 'high'   },
      { name: 'Zoom',             aliases: ['zoom', 'zoom video'],                 category: 'software',  deductible: true,  seedConfidence: 'high'   },
      { name: 'USPS',             aliases: ['usps', 'us postal'],                     category: 'biz_other', deductible: true,  seedConfidence: 'medium' },
      { name: 'FedEx',            aliases: ['fedex', 'federal express'],              category: 'biz_other', deductible: true,  seedConfidence: 'medium' },
      { name: 'UPS',              aliases: ['ups', 'united parcel'],                category: 'biz_other', deductible: true,  seedConfidence: 'medium' },
      { name: 'Office Depot',     aliases: ['office depot', 'officedepot'],           category: 'biz_other', deductible: true,  seedConfidence: 'high'   },
      { name: 'Amazon',           aliases: ['amazon', 'amzn'],          category: 'biz_other', deductible: true,  seedConfidence: 'medium' },
    ],
    communityChannels: ['general', 'tips', 'wins', 'business'],
  },
};

export const PROFESSION_LIST = Object.entries(PROFESSION_MAP).map(([id, config]) => ({
  id,
  ...config,
}));

export function getProfessionConfig(professionType) {
  return PROFESSION_MAP[professionType] || PROFESSION_MAP.other;
}
